import { motion } from "framer-motion";

// Static motion variants shared across the Dashboard sub-cards. Defined
// at module level to avoid creating new objects on every render.
export const FADE_UP = { initial: { opacity: 0, y: 10 }, animate: { opacity: 1, y: 0 } };
export const SLIDE_RIGHT = { initial: { opacity: 0, x: -10 }, animate: { opacity: 1, x: 0 } };

export const stagger = (base, step, idx) => ({ delay: base + idx * step });

// Re-export motion so all card components import a single Framer instance.
export { motion };

// Small helper to format an ISO date as "DD MMM" in Italian.
export function formatDateShort(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short" });
  } catch {
    return "";
  }
}

export const APT_TYPE_COLORS = {
  appuntamento: "#007AFF",
  check: "#D4FF00",
  valutazione: "#34C759",
  prova: "#FF9500",
};

export const APT_TYPE_LABELS = {
  appuntamento: "Appuntamento",
  check: "Check-in",
  valutazione: "Valutazione",
  prova: "Prova gratuita",
};
